
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/editorial-team",
      function () {
        return require("private-next-pages/editorial-team/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/editorial-team"])
      });
    }
  